import { ILeadInfo } from '../../../../../olist-types/LeadInfo';

const PRE_SIGNUP_INITIAL_PRODUCT = {
  name: 'pre-signup',
  id: 'pre-signup',
  category: 'setup',
  list: 'web',
  price: '5',
};

export const getPreSignUpProduct = (isMobile: boolean, additionalProperties?: any) => {
  const list = isMobile ? 'app' : 'web';

  return {
    ...PRE_SIGNUP_INITIAL_PRODUCT,
    list,
    ...additionalProperties,
  };
};

export const getAdditionalProductProperties = (lead: Partial<ILeadInfo>) => {
  const dimension1 =
    lead?.is_already_online_seller === '1'
      ? 'is_already_online_seller'
      : 'not_is_already_online_seller';
  const dimension2 = `integrador_${lead?.integrator}`;
  const price = lead?.is_already_online_seller === '1' ? '6' : '5';
  return { price, dimension1, dimension2 };
};
